import './styles.css';

import React from 'react';
import PropTypes from 'prop-types';



const InformationLabel = (props) => {

    let customStyleInformationLabel = null;
    if(props.isActive) {
        customStyleInformationLabel = {
            color: "#1dbdc0"
        }
    }

    return (

            props.onClick ?
            <div
                className="information-label pointer"
                style={customStyleInformationLabel}
                onClick = {() => {props.onClick(props.id)}}
            >
                {props.infoLabel}
            </div>
            :
            <div
                className="information-label"
                style = {props.customStyleInformationLabelNonClickable}
            >
                {props.infoLabel}
            </div>


    )

};

InformationLabel.propTypes = {
    infoLabel: PropTypes.string.isRequired
};


InformationLabel.defaultProps = {

};

export default InformationLabel;



// WEBPACK FOOTER //
// ./src/components/InformationLabel/InformationLabel.js